
export const AboutPage_PATH: string = 'about';
export const BeerDetailPage_PATH: string = 'beerdetail';
export const AddBeerFormPage_PATH: string = 'addbeer';
export const AddBreweryFormPage_PATH: string = 'addbrewery';
export const AnalysesPage_PATH: string = 'analyses';
export const ApploginPage_PATH: string = 'applogin';
export const AuthPage_PATH: string = 'auth';
export const ContactPage_PATH: string = 'contact';
export const FaqPage_PATH: string = 'faq';
export const HomePage_PATH: string = 'home';
export const LandingPage_PATH: string = 'landing';
export const SearchPage_PATH: string = 'search';
export const SearchBreweryPage_PATH: string = 'searchbrewery';
export const SelectorPopoverPage_PATH: string = 'selector';
export const TabsPage_PATH: string = 'tabs';
export const VenueSelectionPopoverPage_PATH: string = 'venueselector';
export const WebloginPage_PATH: string = 'weblogin';
export const WishlistPage_PATH: string = 'wishlist';
